export default "__VITE_ASSET__639366a3__"